// extracted by mini-css-extract-plugin
module.exports = {"wrap":"frontend-components-student-Password__wrap--1Azpj","strengthBar":"frontend-components-student-Password__strengthBar--2K9Jo"};